import { render, staticRenderFns } from "./UpdateRealmName.vue?vue&type=template&id=138711c1&scoped=true&"
import script from "./UpdateRealmName.vue?vue&type=script&lang=ts&"
export * from "./UpdateRealmName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138711c1",
  null
  
)

export default component.exports